import { createAsyncThunk } from '@reduxjs/toolkit';

import { vpnChecked } from './vpnBehaviorSlice';

import { VpnStatus } from 'features/vpn-behavior/enums';

export const checkVpnStatus = createAsyncThunk(
  'vpn-behavior/checkVpnStatus',
  async (_, { dispatch }) => {
    const isVpn = await checkVpn();
    dispatch(vpnChecked(isVpn ? VpnStatus.Detected : VpnStatus.NotDetected));
  }
);

const sorensonVpnIpRanges = [
  // VPN IP ranges; currently, all Sorenson VPN connections seem to use this single IP address
  '209.169.244.29/32',
];

async function checkVpn(): Promise<boolean> {
  try {
    const publicIpAddress = await getPublicIpAddress();

    return sorensonVpnIpRanges.some((range) =>
      isIpInRange(publicIpAddress, range)
    );
  } catch {
    return false;
  }
}

async function getPublicIpAddress(): Promise<string> {
  const response = await fetch('https://api.ipify.org?format=json');
  if (!response.ok) {
    throw new Error('Failed to retrieve public IP address');
  }
  const data = await response.json();
  return data.ip;
}

function isIpInRange(ip: string, range: string): boolean {
  const [rangeIp, prefixLength] = range.split('/');
  const mask = -1 << (32 - +prefixLength);
  const rangeIpNum = ipToNumber(rangeIp) & mask;
  const ipNum = ipToNumber(ip) & mask;
  return rangeIpNum === ipNum;
}

function ipToNumber(ip: string): number {
  return ip
    .split('.')
    .reduce((acc, octet) => (acc << 8) + Number.parseInt(octet, 10), 0);
}
